module.exports = __webpack_public_path__ + "static/media/USYGY100083.04aa94a5.jpg";